var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{model:{value:(_vm.openPanel),callback:function ($$v) {_vm.openPanel=$$v},expression:"openPanel"}},[_c('landmarks'),_c('constraints')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }